<template>
	<search-list ref="sl" :where="where" api-path="/traceLog/list" :searchKeys="searchKeys" :handleResponse="handleResponse" notSearchAll >
		<mm-lc title="Period">
					<mm-date-range not-default-value date-value v-model="where.updated_at"/>
				</mm-lc>
		<mm-lc title="Adv">
			<mm-adv-select no_paused v-model="where.adv_id" multiple />
		</mm-lc>
		<mm-lc title="Result">
			<mm-select v-model="where.stop_reason" multiple :options="resultOptions"  />
		</mm-lc>
		<mm-lc title="Redirections">
			<mm-select v-model="where.redirections" multiple :options="redirectionOptions"  />
		</mm-lc>
		<mm-lc title="Country">
					<mm-offer-geos v-model="where.country" multiple />
				</mm-lc>
		<mm-lc title="Statistic">
			<el-switch v-model="where.statistic"/>
		</mm-lc>

		<mm-table slot="dataTable" slot-scope="res" :res="res">
			<el-table-column label="Adv Name" prop="adv_name">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column label="Offer Id" prop="offer_id" min-width="150" key="offer_id" v-if="!statistic">
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offer_id" :row_name="sp.row.offer_id" />
			</el-table-column>
			<el-table-column label="Offer Name" prop="offer_name" min-width="150" key="offer_name" v-if="!statistic"/>
			<el-table-column label="Adv Offer Id" prop="adv_offer_id" key="adv_offer_id" v-if="!statistic"/>
			<!-- <el-table-column label="redirections" prop="redirections"/> -->
			<el-table-column label="result" prop="stop_reason">
				<template slot-scope="sp">
					<mm-trace-result :histories="sp.row.histories" :stop_reason="sp.row.stop_reason" :redirections="sp.row.redirections"/>
				</template>
			</el-table-column>
			<el-table-column label="Count" prop="count" key="count" v-if="statistic"/>
			<el-table-column label="Action" key="action" min-width="140" v-if="statistic">
				<template slot-scope="sp">
					<el-button class="el-icon-tickets" type="primary" @click="offers(sp.row)">detail</el-button>
				</template>
			</el-table-column>
			<el-table-column label="Trace At" key="updated_at" min-width="140" v-if="!statistic">
				<template slot-scope="sp">
					<el-row  >{{timeFormat(sp.row.updated_at)}}</el-row>
				</template>
			</el-table-column>
		</mm-table>
	</search-list>
</template>

<script>
const resultClass={
	"reach store":"el-icon-success status-active",
	"reach the end page":"el-icon-question",
	"internal error":"el-icon-error status-warning",
	"back to ourself":"el-icon-warning status-paused",
};
export default {
	data() {
		const searchKeys = {
			offer_id: { label: "Offer Id" },
			adv_offer_id: { label: "Adv Offer Id" }
		};
		return {
			where: {
				statistic:false,
				adv_id:'',
				stop_reason:'',
				redirections:'',
			},
			dialogVisible:false,
			statistic:false,
			searchKeys,
			redirectionOptions:this.$utils._.range(1,12).map(v=>{return {value:v,label:v}}),
			resultOptions:["reach store","reach the end page","internal error","back to ourself"].map(v=>{return {value:v,label:v,class:resultClass[v]}}),
			
		};
	},
	methods: {
		async offers(row){
			// this.where.statistic=false;
			// this.where.adv_id=[row.adv_id];
			// this.where.stop_reason=[row.stop_reason];
			// this.where.redirections=[row.redirections];
			// await this.$refs.sl.refresh();
			const where = {};
			where.statistic=false;
			where.adv_id=[row.adv_id];
			where.stop_reason=[row.stop_reason];
			where.redirections=[row.redirections];
			const routeData = this.$router.resolve({path:this.$route.path,query:{where:JSON.stringify(where)}});
			window.open(routeData.href, '_blank');
		},
		handleResponse(res){
			if(res.rows[0] && res.rows[0].count){
				this.statistic = true;
			}else{
				this.statistic = false;
			}
		},
		timeFormat(date) {
			date = new Date(date);
			return this.$utils.date_format(date, "YYYY-MM-DD hh:mm:ss");
		},
	},
	beforeMount(){
		const query = this.$route.query;
		if(query.where){
			const where = JSON.parse(query.where);
			for(let k in where){
				this.where[k] = where[k];
			}
			this.$router.replace({path:this.$route.path});
		}
		
	}
};
</script>

<style scoped>
.result{
	font-size: 16px;
}
</style>


